<div class="modal-content modal-milvus">
    <div class="modal-header">
        <h6 class="modal-title" id="modal-title-default">{{'AVISO' | translate}}</h6>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
            <i class="mdi mdi-close"></i>
        </button>
    </div>
    <div class="modal-body">
        <div [innerHTML]="descricao"></div> 
    </div>
</div>
